import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-blush/30 px-3 py-4 sm:px-6" data-id="element-42" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-43" data-mp="1hdup6krjl7as">
        <h2 className="text-center text-lg font-extrabold uppercase text-navy sm:text-3xl" data-id="element-44" data-mp="1cf04tedxfaok">
          Frequently asked questions
        </h2>
        <ul className="mt-2 space-y-1.5" data-id="element-45" data-mp="2a1qh7c662b18">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-md border border-navy/10 bg-white" data-id="element-46" data-mp="2042iyc9cqleb" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left font-heading text-sm font-bold text-navy transition-colors duration-150 ease-out hover:text-magenta sm:text-base" data-id="element-47" data-mp="1v4zp7nyto1ln">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-magenta transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="1pmb9kqubype7" />
                </button>
                {isOpen ? <p id={`faq-${i}`} className="px-2.5 pb-2 text-sm leading-snug sm:text-base" data-id="element-49" data-mp="11wgwc863mytf">
                    {f.a}
                  </p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}